module.exports = __webpack_public_path__ + "static/img/150-150.4ee1180.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader/GIF1/150-150.gif
// module id = i7jI
// module chunks = 7